import React, { createContext, useContext, useEffect, useState } from "react";
import { login as apiLogin, register as apiRegister, getMe } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    const token = localStorage.getItem("wh_token");
    if (!token) { setUser(null); return; }
    getMe().then(setUser).catch(() => { localStorage.removeItem("wh_token"); setUser(null); });
  }, []);

  const loginUser = async (email, password) => {
    const data = await apiLogin({ email, password });
    localStorage.setItem("wh_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const registerUser = async (payload) => {
    const data = await apiRegister(payload);
    localStorage.setItem("wh_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("wh_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loginUser, registerUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
